import { apiSlice } from "../apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/token/",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    signup: builder.mutation({
      query: (credentials) => ({
        url: "/org/admin/signup",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    loginWithRefreshToken: builder.mutation({
      query: (refreshToken) => ({
        url: "/token/refresh/",
        method: "POST",
        body: { ...refreshToken },
      }),
    }),
    forgetPassword: builder.mutation({
      query: (email) => ({
        url: "/org/employee/forget_password/",
        method: "POST",
        body: { ...email },
      }),
    }),
    resetPassword: builder.mutation({
      query: (newPassword) => ({
        url: "/org/employee/forget_password/",
        method: "PUT",
        body: { ...newPassword },
      }),
    }),
    loginWithGoogle: builder.mutation({
      query: (auth_token) => ({
        url: "social_auth/google/",
        method: "POST",
        body: { auth_token },
      }),
    }),
    emailVerification: builder.mutation({
      query: (verifyData) => ({
        url: "org/admin/email-verify/",
        method: "PUT",
        body: { ...verifyData },
      }),
    })
  }),
});

export const { useLoginMutation, useLoginWithRefreshTokenMutation, useForgetPasswordMutation, useResetPasswordMutation, useLoginWithGoogleMutation, useSignupMutation, useEmailVerificationMutation } =
  authApiSlice;